import React, { createContext, useState, useEffect, useContext } from "react";
import API from "../api/axiosConfig";
import { useNavigate } from "react-router-dom"; 

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userEmail, setEmail] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); 
  
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await API.post("/api/users/info");
        setUser(response.data);
        setEmail(response.data.email);
        // Crucial: Set the admin status here!
        const isUserAdmin =
          response.data.groups &&
          response.data.groups.includes("Administrator");
        setIsAdmin(isUserAdmin);
      } catch (err) {
        // If cookie is missing or invalid (401), or server fails, reset session state
        setUser(null);
        setEmail(null);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  // Logout Helper: Calls server to wipe HttpOnly cookies and clears React state
  const logout = async () => {
    try {
      await API.post("/api/auth/logout");
    } catch (err) {
      console.error("Logout error on server:", err);
    } finally {
      setUser(null);
      setEmail(null);
      setIsAdmin(false);
      navigate("/", { replace: true });
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        userEmail,
        setEmail,
        isAdmin,
        setIsAdmin,
        loading,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
